<template>
    <div class="auth authBgColor" v-testdata="{section: 'login_form'}">
        <div class="container container--center">
            <div class="auth__containerAdaptive">
                <div class="auth__left" id="col-auth-left">
                    <div class="auth__imgCompany">
                        <img :src="domain_logo ? domain_logo : '/common/images/logo_aira_sm.png'" alt="">
                    </div>
                    <div class="auth__left__content">
                        <div class="row margin-none">
                            <div class="col s12 pad-none">
                                <h1 class="auth__title authColor">{{ $t('auth.login_form.title') }}</h1>
                                <div v-if="alert_type" :class="`alert${alert_type} alert${alert_type}--inline margin-bot-mid`" v-html="alert_message"></div>
                                <div class="row margin-bot-none">
                                    <div class="col s12">
                                        <!--Tabs-->
                                        <ul v-if="show_login_tabs" class="tabs tabs-fixed-width tabs--custom margin-bot">
                                            <li class="tab">
                                                <a @click="changeTab('applicant')" class="active" href="#applicant">
                                                    {{ getFeatureByBaseLocale(applicant_tab_names, $t('auth.login_form.actions.tabs.applicant')) }}
                                                </a>
                                            </li>
                                            <li class="tab">
                                                <a @click="changeTab('recruiter')" href="#recruiter">
                                                    {{ getFeatureByBaseLocale(recruiter_tab_names, $t('auth.login_form.actions.tabs.company')) }}
                                                </a>
                                            </li>
                                        </ul>
                                        <!--/Tabs-->
                                        <!-- candidate -->
                                        <div id="applicant" v-testdata="{section: 'applicant_login'}">
                                            <form v-if="!applicant_login_disabled" @submit.prevent="loginApplicant">
                                                <div class="row margin-bot-none">
                                                    <div class="col s12 input-field">
                                                        <input 
                                                            id="email101" type="email" name="email" class="auth--input"
                                                            :class="{ invalid: $v.applicant.email.$error }"
                                                            :placeholder="$t('auth.login_form.placeholders.email')"
                                                            v-model="applicant.email"
                                                            v-testdata="{input_id: 'email'}"
                                                        >
                                                        <label for="email101" class="base-fontsize active">{{ $t('auth.login_form.labels.email') }}</label>
                                                        <validationErrors
                                                            :validation_field="$v.applicant.email"
                                                            name="email"
                                                            lang_prefix="validation"
                                                            class="validation-error--marginNone"
                                                        ></validationErrors>
                                                    </div>
                                                </div>
                                                <div class="row margin-bot-none">
                                                    <div class="col s12 input-field">
                                                        <div class="input-field-password">
                                                            <input
                                                                id="password101" type="password" name="password" class="auth--input"
                                                                :class="{ invalid: $v.applicant.password.$error }"
                                                                :placeholder="$t('auth.login_form.placeholders.password')"
                                                                v-model="applicant.password"
                                                                v-testdata="{input_id: 'password'}"
                                                            >
                                                            <i id="icon101" onclick="showPassword(101)" class="cursor-pointer fas fa-eye-slash"></i>
                                                            <validationErrors
                                                                :validation_field="$v.applicant.password"
                                                                name="password"
                                                                lang_prefix="validation"
                                                                class="validation-error--marginNone"
                                                            ></validationErrors>
                                                        </div>
                                                        <label for="password101" class="base-fontsize active">{{ $t('auth.login_form.labels.password') }}</label>
                                                        <a class="right underline margin-top-mid small-fontsize authColor" href="/password/reset">{{ $t('auth.login_form.actions.remember_password') }}</a>
                                                    </div>
                                                </div>
                                                <div class="margin-top-mid" v-if="!show_register">
                                                    <button type="submit" v-testdata="{btn: 'login'}" class="btnPrimary fullwidth" :disabled="applicantSubmitting">{{ $t(`auth.login_form.actions.log_in_button${applicantSubmitting?'_active':''}`) }}</button>
                                                </div>
                                                <!-- Register buttons -->
                                                <div class="auth__buttonsContainer margin-top-mid" v-else>
                                                    <a class="btnSecondary" v-testdata="{btn: 'register_form'}" :href="`/register${session_email?'?email='+session_email:''}`">{{ $t('auth.login_form.actions.sign_up_button') }}</a>
                                                    <button type="submit" v-testdata="{btn: 'login'}" class="btnPrimary" :disabled="applicantSubmitting">{{ $t(`auth.login_form.actions.log_in_button${applicantSubmitting?'_active':''}`) }}</button>
                                                </div>
                                                <!-- /Register buttons -->
                                                <div class="auth__separator margin-top-mid">
                                                    <hr class="auth__separator__line">
                                                    <span class="auth__separator__text">o</span>
                                                    <hr class="auth__separator__line">
                                                </div>
                                                <social-login :social_login="social_login"></social-login>
                                            </form>
                                            <template v-for="(provider_config, provider) in applicant_login_providers">
                                                <div class="margin-top">
                                                    <template v-if="provider_config.type == 'gigya'">
                                                        <a
                                                            href="#"
                                                            :class="`btnSecondary btnSecondary--auth fullwidth ${provider_config.type}-btn ${provider}-btn`"
                                                            @click="showGigyaScreen(provider_config.screen_set, provider_config.start_screen)"
                                                        >
                                                            {{ provider_config.name ? provider_config.name : provider }}
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <a
                                                            :href="provider_config.auth_url? provider_config.auth_url : `/login/auth/${provider}`"
                                                            :class="`btnSecondary btnSecondary--auth fullwidth ${provider_config.type}-btn ${provider}-btn ${provider}-btn`"
                                                        >
                                                            {{ provider_config.name ? provider_config.name : provider }}
                                                        </a>
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-if="Object.keys(applicant_login_footer_content).length > 0">
                                                <div class="margin-top">
                                                    <div class="small-fontsize center">
                                                        <p class="margin-none" v-html="getFeatureByBaseLocale(applicant_login_footer_content, '')"></p>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-if="toolboxCandidateUrl">
                                                <div class="margin-top">
                                                    <application-tool-box-message :toolbox-candidate-url="toolboxCandidateUrl"></application-tool-box-message>
                                                </div>
                                            </template>
                                        </div>
                                        <!-- /candidate -->
                                        <!-- company -->
                                        <div v-if="show_login_tabs" id="recruiter" v-testdata="{section: 'recruiter_login'}">
                                            <form v-if="!recruiter_login_disabled" @submit.prevent="loginRecruiter">
                                                <div class="row margin-bot-none">
                                                    <div class="col s12 input-field">
                                                        <input
                                                            id="email102" type="email" name="email" class="auth--input"
                                                            :class="{ invalid: $v.recruiter.email.$error }"
                                                            :placeholder="$t('auth.login_form.placeholders.email')"
                                                            v-model="recruiter.email"
                                                            v-testdata="{input_id: 'email'}"
                                                        >
                                                        <label for="email102" class="base-fontsize active">
                                                            {{ $t('auth.login_form.labels.email') }}
                                                        </label>
                                                        <validationErrors
                                                            :validation_field="$v.recruiter.email"
                                                            name="email"
                                                            lang_prefix="validation"
                                                            class="validation-error--marginNone"
                                                        ></validationErrors>
                                                    </div>
                                                </div>
                                                <div class="row margin-bot-none">
                                                    <div class="col s12 input-field">
                                                        <div class="input-field-password">
                                                            <input
                                                                id="password102" type="password" name="password" class="auth--input"
                                                                :class="{ invalid: $v.recruiter.password.$error }"
                                                                :placeholder="$t('auth.login_form.placeholders.password')"
                                                                v-model="recruiter.password"
                                                                v-testdata="{input_id: 'password'}"
                                                            >
                                                            <i id="icon102" onclick="showPassword(102)" class="cursor-pointer fas fa-eye-slash"></i>
                                                        </div>
                                                        <label for="password102" class="base-fontsize active">
                                                            {{ $t('auth.login_form.labels.password') }}
                                                        </label>
                                                        <validationErrors
                                                            :validation_field="$v.recruiter.password"
                                                            name="password"
                                                            lang_prefix="validation"
                                                            class="validation-error--marginNone"
                                                        ></validationErrors>
                                                        <a class="right underline margin-top-mid small-fontsize authColor" href="/recruiter/password/reset">
                                                            {{ $t('auth.login_form.actions.remember_password') }}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="margin-top-mid">
                                                    <button type="submit" v-testdata="{btn: 'login'}" class="btnPrimary fullwidth" :disabled="recruiterSubmitting">
                                                        {{ $t(`auth.login_form.actions.log_in_button${recruiterSubmitting?'_active':''}`) }}
                                                    </button>
                                                </div>
                                            </form>
                                            <template v-for="(provider_config, provider) in recruiter_login_providers">
                                                <div class="margin-top">
                                                   
                                                    <template v-if="provider_config.type == 'gigya'">
                                                        <a
                                                            href="#"
                                                            :class="`btnSecondary btnSecondary--auth fullwidth ${provider_config.type}-btn ${provider}-btn`"
                                                            @click="showGigyaScreen(provider_config.screen_set, provider_config.start_screen)"
                                                        >
                                                            {{ provider_config.name ? provider_config.name : provider }}
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <a
                                                            :href="provider_config.auth_url? provider_config.auth_url : `/recruiter/login/auth/${provider}`"
                                                            :class="`btnSecondary btnSecondary--auth fullwidth ${provider_config.type}-btn ${provider}-btn`"
                                                        >
                                                            {{ provider_config.name ? provider_config.name : provider }}
                                                        </a>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                        <!-- company -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="auth__right" id="col-auth-right">
                    <img class="auth__right__img" :class="{'hide': !tab_applicant}" :src="applicant_login_image_in_locale" alt="">
                    <img class="auth__right__img" :class="{'hide': !tab_recruiter}" :src="recruiter_login_image_in_locale" alt="">
                    <div class="auth__right__info">
                        <div class="row margin-none pad-mid">
                            <div class="col s12" v-if="tab_applicant">
                                <p v-for="(login_message, idx) in login_messages['applicant']" :key="idx">{{ login_message }}</p>
                            </div>
                            <div class="col s12" v-if="tab_recruiter">
                                <p v-for="(login_message, idx) in login_messages['recruiter']" :key="idx">{{ login_message }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import * as M from "materialize-css";
import Loading from "vue-loading-overlay";
import validationErrors from "../ValidationErrors.vue";
import {
    required,
    email,
    helpers
} from "vuelidate/lib/validators";
import { loginRecruiter, loginApplicant } from "../../api/auth";
import SocialLogin from "./SocialLogin.vue";
import ApplicationToolBoxMessage from '../applicant/common/ApplicationToolBoxMessage.vue';

const requiredWithAttribute = (attribute) => helpers.withParams({ type: 'required', attribute: attribute }, required);

const emailWithAttribute = (attribute) => helpers.withParams({ type: "email", attribute: attribute }, email);

const serverFailed = (errors) => helpers.withParams(
    { type: 'serverFailed', custom_message: ((errors.length > 0) ? errors[0] : '') },
    (value) => (errors.length === 0)
);

export default {
    name: "UserLogin",
    mixins: [ validationMixin ],
    components: {
        validationErrors,
        SocialLogin,
        ApplicationToolBoxMessage
    },
    props: {
        alert_type: {
            type: String
        },
        alert_message: {
            type: String
        },
        domain_logo: {
            type: String
        },
        show_login_tabs: {
            type: Boolean,
            default: true,
        },
        applicant_tab_names: {
            type: Object,
            default: () => ({})
        },
        recruiter_tab_names: {
            type: Object,
            default: () => ({})
        },
        applicant_login_disabled: {
            type: Boolean,
            default: false,
        },
        recruiter_login_disabled: {
            type: Boolean,
            default: false
        },
        show_register: {
            type: Boolean,
            default: false,
        },
        session_email: {
            type: String,
            default: '',
        },
        applicant_login_providers: {
            type: Object,
            default: () => ({})
        },
        recruiter_login_providers: {
            type: Object,
            default: () => ({})
        },
        social_login: {
            type: Object,
            default: () => ({})
        },
        applicant_login_footer_content: {
            type: Object,
            default: () => ({})
        },
        applicant_login_image: {
            type: Object,
            default: () => ({})
        },
        recruiter_login_image: {
            type: Object,
            default: () => ({})
        },
        login_messages: {
            type: Object,
            default: () => ({})
        },
        toolboxCandidateUrl: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            applicantSubmitting: false,
            recruiterSubmitting: false,
            base_locale: 'es',
            tab_applicant: true,
            tab_recruiter: false,
            applicant_login_image_in_locale: '',
            recruiter_login_image_in_locale: '',
            applicant: {
                email: '',
                password: ''
            },
            recruiter: {
                email: '',
                password: ''
            },
            serverErrors: {
                applicant: {
                    email: [],
                    password: []
                },
                recruiter: {
                    email: [],
                    password: []
                }
            }
        }
    },
    validations() {
        let email_attribute = this.$i18n.t('auth.login_form.labels.email').toLowerCase();
        let password_attribute = this.$i18n.t('auth.login_form.labels.password').toLowerCase();

        let validations = {
            applicant: {
                email: {
                    required: requiredWithAttribute(email_attribute),
                    email: emailWithAttribute(email_attribute),
                    serverFailed: serverFailed(this.serverErrors.applicant.email)
                },
                password: {
                    required: requiredWithAttribute(password_attribute),
                    serverFailed: serverFailed(this.serverErrors.applicant.password)
                },
            },
            recruiter: {
                email: {
                    required: requiredWithAttribute(email_attribute),
                    email: emailWithAttribute(email_attribute),
                    serverFailed: serverFailed(this.serverErrors.recruiter.email)
                },
                password: {
                    required: requiredWithAttribute(password_attribute),
                    serverFailed: serverFailed(this.serverErrors.recruiter.password)
                },
            }
        };

        return validations;
    },
    created: function () {
        this.base_locale = this.$i18n.locale.slice(0,2);
        window.addEventListener('hashchange', this.setActiveTab);
        this.$nextTick(this.initFields);
    },
    mounted: function () {
        if (this.session_email.length > 0) {
            let hash = window.location.hash.replace(/[#/]/g,'');
            if(hash == 'recruiter'){
                this.recruiter.email = this.session_email;
            }else{
                this.applicant.email = this.session_email;
            }
        }
        this.setLoginImages();
        setUserTypeInWidget('Candidato');
        this.$nextTick(this.setActiveTab);
    },
    computed: {
    },
    methods: {
        initFields() {
            let tabs = this.$el.querySelectorAll(".tabs");
            M.Tabs.init(tabs, {});
        },
        changeTab(profile){
            window.location.hash = profile;
            this.moveScrollPrev();
        },
        moveScrollPrev(){
            const firstElement = document.getElementById(`auth_user_login`);
            if(firstElement){
                const topPos = firstElement.scrollTop;
                document.getElementById(`auth_user_login`).scrollTop = topPos;
            }
        },
        setActiveTab(){
            let hash = window.location.hash.replace(/[#/]/g,'');
            let elem = this.$el.querySelectorAll(".tabs");
            if (elem.length){
                let instance = M.Tabs.getInstance(elem[0]);
                instance.select(hash);
                if(hash.length > 0){
                    switch (hash) {
                        case 'recruiter':
                            setUserTypeInWidget('Empresa');
                            this.tab_applicant = false;
                            this.tab_recruiter = true;
                            break;
                        case 'applicant':
                        default:
                            setUserTypeInWidget('Candidato');
                            this.tab_applicant = true;
                            this.tab_recruiter = false;
                            break;
                    }
                }
            }
        },
        getFeatureByBaseLocale(feature_array, default_value) {
            if(feature_array[this.base_locale]) {
                return feature_array[this.base_locale];
            }
            if(feature_array['default']) {
                return feature_array['default'];
            }
            return default_value;
        },
        showGigyaScreen(screen_set, start_screen) {
            gigya.accounts.showScreenSet({
                screenSet: (screen_set ? screen_set : 'Default-RegistrationLogin'),
                startScreen: (start_screen ? start_screen : 'gigya-login-screen')
            });
        },
        setLoginImages() {
            this.applicant_login_image_in_locale = this.getFeatureByBaseLocale(this.applicant_login_image, `/common/images/login/aira/applicant/background_login_${this.base_locale}.png`);
            this.recruiter_login_image_in_locale = this.getFeatureByBaseLocale(this.recruiter_login_image, `/common/images/login/aira/recruiter/background_login_${this.base_locale}.png`);
        },
        async loginApplicant() {
            const vm = this;
            vm.serverErrors.applicant = { email: [], password: [] };
            vm.$v.applicant.$touch();
            if (!vm.$v.applicant.$invalid) {
                vm.applicantSubmitting = true;
                await loginApplicant(vm.applicant)
                    .then(response => {
                        window.location = response.data.redirectTo ? response.data.redirectTo : '/';
                    })
                    .catch(error => {
                        Object.keys(error.data).forEach(key => {
                            vm.serverErrors.applicant[key].push(error.data[key][0]);
                        });
                        vm.$v.applicant.$touch();
                    });
                vm.applicantSubmitting = false;
            }
        },
        async loginRecruiter() {
            const vm = this;
            vm.serverErrors.recruiter = { email: [], password: [] };
            vm.$v.recruiter.$touch();
            if (!vm.$v.recruiter.$invalid) {
                vm.recruiterSubmitting = true;
                await loginRecruiter(vm.recruiter)
                    .then(response => {
                        window.location = response.data.redirectTo ? response.data.redirectTo : '/';
                    })
                    .catch(error => {
                        Object.keys(error.data).forEach(key => {
                            vm.serverErrors.recruiter[key].push(error.data[key][0]);
                        });
                        vm.$v.recruiter.$touch();
                    });
                vm.recruiterSubmitting = false;
            }
        },
    }
}
</script>